<template>
  <transition-group
    name="book-card-fade"
    tag="div"
    class="book-gallery">
    <book-card
      :is-book-linked="areBooksLinked"
      :key="book.id"
      v-for="book in books"
      v-bind="book"
      class="book-gallery__item" />
  </transition-group>
</template>

<script>
import BookCard from "/shared/book-card/book-card";

export default {
  name: "BookGallery",
  components: { BookCard },
  props: {
    books: { type: Array, default: () => [] },
    areBooksLinked: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss">
.book-gallery {
  $books-displayed: (
    xs: 3,
    s: 3,
    m: 4,
    l: 6
  );
  $books-per-row: (
    xs: 1,
    s: 1,
    m: 2,
    l: 3
  );

  @include grid;

  justify-content: center;

  &__item {
    display: none;

    flex-grow: 1;

    @each $break, $gutter in $grid-gutters {

      @include media(min-width, $break) {
        $number-per-row: map-get($books-per-row, $break);
        $number-displayed: map-get($books-displayed, $break);
        $columns: $grid-css-total-columns / $number-per-row;

        @include grid-element($columns);

        &:nth-child(-n+#{$number-displayed}) {
          display: flex;
        }

        &:nth-child(-n+#{$number-displayed - $number-per-row}) {
          margin-bottom: $gutter;
        }
      }
    }
  }

  /* stylelint-disable selector-nested-pattern */
  .book-card-fade-enter-active,
  .book-card-fade-leave-active {
    @include ease(opacity, 0.15s);
  }

  .book-card-fade-enter,
  .book-card-fade-leave-to {
    opacity: 0;
  }
}
</style>
